export const ContactUsStyles = {
  EmpoweredQuoteContainer: {
    // display: "flex",
    alignItems: "center",
    // justifyContent: "center",
    // py: 2,
  },
  HeadingTxtContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // width: "90%",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "2rem",
    // padding: "2rem",
    // flexDirection: { md: "row" },
    justifyContent: { md: "center" },
    padding: { md: "4rem" },
    // [theme.breakpoints.up("md")]: {
    //   flexDirection: "row",
    //   justifyContent: "center",
    //   padding: "4rem",
    // },
  },
  textSection: {
    // textAlign: "center",
    maxWidth: "500px",
    textAlign: { md: "left" },
  },
  heading: {
    fontSize: "2rem",
    fontWeight: 600,
    marginBottom: "1rem",
    fontFamily: '"Poppins", serif',
  },
  subtext: {
    fontSize: "1rem",
    color: "#666",
    fontFamily: '"Poppins", serif',
  },
  formCard: {
    maxWidth: "500px",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
    background: "linear-gradient(to bottom, #f9f9f9, #e6ecf5)",
  },
  formHeading: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "1rem",
    fontFamily: '"Poppins", serif',
  },
  highlight: {
    color: "#0056E9",
  },
  formSubtext: {
    fontSize: "0.9rem",
    color: "#777",
    textAlign: "center",
    marginBottom: "1.5rem",
    fontFamily: '"Poppins", serif',
  },
  formGrid: {
    marginBottom: "1rem",
  },
  privacyText: {
    fontSize: "0.8rem",
    color: "#777",
    textAlign: "center",
    marginTop: "1rem",
    fontFamily: '"Poppins", serif',
  },
  privacyLink: {
    color: "#0056E9",
    fontWeight: "bold",
    cursor: "pointer",
  },
  submitButton: {
    // background: "#0056E9",
    background: "linear-gradient(93.14deg, #1E90FF, #63B8FF)",
    color: "#fff",
    padding: "12px 24px",
    width: "100%",
    borderRadius: "8px",
    marginTop: "1.5rem",
    fontFamily: '"Poppins", serif',
    "&:hover": {
      // background: "#003bb1",
      background: "linear-gradient(93.14deg, #63B8FF, #1E90FF, )",
    },
  },
  LabelTxt: {
    fontWeight: 500,
    fontSize: "1rem",
    mb: 1,
    fontFamily: '"Poppins", serif',
    display: "flex",
    alignItems: "center",
  },
  LabelValueTxt: {
    fontWeight: 400,
    fontSize: "1rem",
    // mb: 1,
    color: "#808080",
    fontFamily: '"Poppins", serif',
    mx: 1,
  },
};

export const TravelAssistanceStyles = {
  MainBannerBox: {
    position: "relative",
    overflow: "hidden",
    padding: "30px 35px",
    textAlign: "center",
    "& .leftShade1": {
      position: "relative",
      zIndex: 999,
      boxShadow: "39px -9px 60px 49px #000000",
    },
    "& video": {
      objectFit: "cover",
      width: "100vw",
      height: "100vh",
      position: "absolute",
      top: 0,
      left: 0,
    },
  },
};

export const GadgetsProtectionStyles = {
  BackgroundBox: (blogBackground) => ({
    backgroundImage: `url(${blogBackground})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  }),
  TabStyle: {
    fontSize: { xs: "0.9rem", sm: "1rem", md: "1.2rem" },
    fontFamily: '"Poppins", serif',
  },
  HeadingTypography: {
    textAlign: "left",
    fontFamily: '"Poppins", serif',
    fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.5rem" },
  },
  UnderlinedText: {
    color: "#333",
    textDecoration: "underline",
    textDecorationColor: "#2196f3",
    fontFamily: '"Poppins", serif',
  },
  TextFieldStyle: {
    "& .MuiInputBase-input": {
      fontFamily: '"Poppins", serif',
    },
    "& .MuiInputLabel-root": {
      fontFamily: '"Poppins", serif',
    },
  },
  FindPlansButton: {
    mt: 2,
    fontFamily: '"Poppins", serif',
  },
  CenteredBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  PlanHeading: {
    fontFamily: '"Poppins", serif',
    fontSize: { xs: "1.2rem", sm: "1.2rem", md: "1.8rem" },
  },
  SubHeading: {
    fontFamily: '"Poppins", serif',
    fontSize: { xs: "1rem", sm: "1rem", md: "1.2rem" },
  },
  GridCentered: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  RightSectionBox: {
    p: 4,
    boxShadow: 3,
    borderRadius: 2,
    backgroundColor: "white",
  },
  RightSectionHeading: {
    fontFamily: '"Poppins", serif',
    fontWeight: 600,
    mb: 3,
    textAlign: "left",
  },
};
